'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Functions = require('../core/Functions');

var _RootNode = require('../utils/RootNode');

var _component = require('../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _domElement = require('../utils/propTypes/domElement');

var _domElement2 = _interopRequireDefault(_domElement);

var _PortalLayer = require('./internal/PortalLayer');

var _PortalLayer2 = _interopRequireDefault(_PortalLayer);

var _SubtreeLayer = require('./internal/SubtreeLayer');

var _SubtreeLayer2 = _interopRequireDefault(_SubtreeLayer);

var _ClickableContext = require('../context/ClickableContext');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UILayer = function (_React$Component) {
  _inherits(UILayer, _React$Component);

  function UILayer(props) {
    _classCallCheck(this, UILayer);

    var _this = _possibleConstructorReturn(this, (UILayer.__proto__ || Object.getPrototypeOf(UILayer)).call(this, props));

    _this._rootNode = props.rootNode || (0, _RootNode.getDefaultNode)();
    _this._element = document.createElement('div');
    _this._element.className = 'private-layer';
    _this._element.setAttribute('data-layer-for', props['data-layer-for']);
    _this._rootNode.appendChild(_this._element);

    _this.handleCloseComplete = _this.handleCloseComplete.bind(_this);
    _this.renderTree = _this.renderTree.bind(_this);
    return _this;
  }

  _createClass(UILayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        var layerFor = _this2.props['data-layer-for'];

        if (_this2._clickableContext) _this2._clickableContext(layerFor);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var Transition = this.props.Transition;

      if (!Transition) this.handleCloseComplete();
    }
  }, {
    key: 'handleCloseComplete',
    value: function handleCloseComplete() {
      var _props = this.props,
          onCloseComplete = _props.onCloseComplete,
          transitionProps = _props.transitionProps;

      (0, _Functions.callIfPossible)(transitionProps && transitionProps.onCloseComplete);
      (0, _Functions.callIfPossible)(onCloseComplete);
      if (!_reactDom2.default.createPortal) {
        _reactDom2.default.unmountComponentAtNode(this._element);
      }
      this._rootNode.removeChild(this._element);
    }
  }, {
    key: 'renderTree',
    value: function renderTree(content, forceTransitionOnMount) {
      var _props2 = this.props,
          Transition = _props2.Transition,
          transitionProps = _props2.transitionProps;


      if (!Transition) return content;
      return _react2.default.createElement(
        Transition,
        _extends({}, transitionProps, {
          onCloseComplete: this.handleCloseComplete,
          transitionOnMount: forceTransitionOnMount || transitionProps && transitionProps.transitionOnMount
        }),
        content
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var children = this.props.children;

      var LayerRenderer = _reactDom2.default.createPortal ? _PortalLayer2.default : _SubtreeLayer2.default;
      return _react2.default.createElement(
        _ClickableContext.ClickableContextConsumer,
        null,
        function (clickableContext) {
          _this3._clickableContext = clickableContext;
          return _react2.default.createElement(
            LayerRenderer,
            { element: _this3._element, renderTree: _this3.renderTree },
            children
          );
        }
      );
    }
  }]);

  return UILayer;
}(_react2.default.Component);

UILayer.propTypes = {
  children: _react.PropTypes.node.isRequired,
  'data-layer-for': _react.PropTypes.string,
  onCloseComplete: _react.PropTypes.func,
  rootNode: _domElement2.default,
  Transition: _component2.default,
  transitionProps: _react.PropTypes.object
};

UILayer.displayName = 'UILayer';

exports.default = UILayer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/layer/UILayer.js
// module id = 436
// module chunks = 3 4 5